import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { IDragFileBrowseData, IReturnChangesWidgetEditForm, checkIfFieldDisabled, widgetEditMode } from 'na-lib/dist/network/widgets.dto';
import { MediaDialogHandlerComponent } from 'src/app/media/media-dialog-handler/media-dialog-handler.component';
import { supportUrlStructure } from 'src/app/supportUrls';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FileHandle } from 'src/app/directive/drag-and-drop.directive';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { deepCopy, languagesList, languagesList_ } from 'na-lib';
import { CommentsService } from 'src/app/service/comments.service';
import { SettingsService } from 'src/app/service/settings.service';
import { UploadService } from 'src/app/service/upload.service';
import { checkUrlProtocol, urlInvalidCharactersValidator } from 'src/app/validators/formValidators.dt';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

type LinkChip =
  | { kind: 'child'; id: string; label: string }
  | { kind: 'anchor'; id: string; label: string };

interface AnchorOption {
  id: string;
  label?: string;
  name?: string;
}
interface ChildPageOption {
  id: string;
  name?: string;
}

@Component({
    selector: 'app-billboard-img-edit-form',
    templateUrl: './billboard-img-edit-form.component.html',
    styleUrl: './billboard-img-edit-form.component.css',
    standalone: false
})
export class BillboardImgEditFormComponent {
  @Input() data:widgetEditMode
  @Output() returnChanges = new EventEmitter<IReturnChangesWidgetEditForm>()
  @Output() formChange = new EventEmitter<FormGroup>();

  billboardData:any
  oldData:any
  changes=false
  billboardImgEditForm!: FormGroup
  billboardImgEditTranslationForm!: FormGroup
  url:any
  noUrl=false
  newImage:any=[]
  idToShow:any
  widgetNumber:any
  passId:any
  files: FileHandle[] = []
  drop=false
  urlData:any
  linkURL:any
  urlRegex = /^(?:\$\{[A-Za-z0-9._:-]+\}|#\S+|child:[^\s]+|dpp:\/\/main|(?:https?:\/\/|context:\/\/|pass:\/\/|content:\/\/|task:\/\/|tridy:\/\/)\S+)$/;
  urlRegexDoc = /^(?:\$\{[^}]+\}|pass:\/\/[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+)$/;
  urlRegexDynamic = /^\$\{[A-Za-z0-9._:-]+\}$/;

  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;
  addUrl: boolean = false;
  languagesList = languagesList
  defaultLanguage:string
  dynamicUrl = false
  dragFileData: IDragFileBrowseData
  translationModeOriginal = false

  anchorOptions: AnchorOption[] = [];
  childPages: ChildPageOption[] = [];
  linkChip: LinkChip | null = null;
  private destroy$ = new Subject<void>();

  constructor(
    private fb: FormBuilder,
    public dialog: MatDialog,
    private uploadService: UploadService,
    private commentService: CommentsService,
    private translate:TranslateService,
    private settingsService: SettingsService
    ){
    const currentLang = this.translate.currentLang() ?? 'en';
    this.languagesList = languagesList_[currentLang]
  }

  ngOnInit():void{
    this.defaultLanguage = this.data.defaultLanguage
    this.billboardData=this.data.values
    this.oldData=this.billboardData
    this.url=this.oldData.url
    this.passId = this.data['passId']
    this.idToShow = this.passId
    this.widgetNumber= this.data['widget']

    if(this.data.translateMode){
      let translateData = this.data.translateData
      const {fields, originalLanguageData, defaultLanguageWidgetData, valuesTranslated, selectedLanguage, values} = translateData

      if(translateData.originalLanguageData){
        this.translationModeOriginal = true
        this.dragFileData = translateData.dragFileDataOriginal
        this.initTranslateEditData( defaultLanguageWidgetData, valuesTranslated, originalLanguageData, [],selectedLanguage)
      }else{
        this.translationModeOriginal = false

        this.dragFileData = translateData.dragFileData
        this.initTranslateEditData(values,valuesTranslated, originalLanguageData, fields, selectedLanguage)
      }
    }
    else
    this.initWidgetEdit()
    const extra = this.data as any;
    this.anchorOptions = extra.anchorOptions || [];
    this.childPages   = extra.childPages || [];
    const ctrl = this.billboardImgEditForm?.get('linkURL');

    if (ctrl) {
      this.linkChip = this.makeLinkChip(ctrl.value);
      ctrl.valueChanges.subscribe(v => {
        this.linkChip = this.makeLinkChip(v);
      });
    }
  }

  initTranslateEditData(data, valuesTranslated, originalLanguageData, fields, selectedLanguage){
    let {id, filter, imageSize, type, title, subtitle, url, linkURL, name, altTitle, fallbackUrl} = data

    //console.log('initTranslateEditData', data, valuesTranslated, originalLanguageData, fields, selectedLanguage)
    if(url)
    this.urlData = supportUrlStructure(url, this.passId, this.settingsService.contextId$)

    if(!originalLanguageData){
      linkURL = valuesTranslated[selectedLanguage +'.'+id+'.linkURL']
      url = valuesTranslated[selectedLanguage +'.'+id+'.url']
      altTitle = valuesTranslated[selectedLanguage +'.'+id+'.altTitle']
    }

    this.billboardImgEditForm = this.fb.group({
      id: [{value:id ? id : undefined, disabled: checkIfFieldDisabled('id', fields, originalLanguageData)}],
      imageSize:[{value:imageSize ? imageSize : undefined, disabled: checkIfFieldDisabled('imageSize', fields, originalLanguageData)}],
      type:[{value:type ? type : undefined, disabled: originalLanguageData || checkIfFieldDisabled('type', fields, originalLanguageData)}],
      title:[{value:title ? title :undefined, disabled: checkIfFieldDisabled('title', fields, originalLanguageData)}],
      subtitle:[{value: subtitle ? subtitle : undefined, disabled: checkIfFieldDisabled('subtitle', fields, originalLanguageData)}],
      //url:[{value:url ? url : undefined, disabled: checkIfFieldDisabled('url', fields, originalLanguageData)}, [ checkUrlProtocol]],
      url: [
        { value: url ? url : undefined, disabled: checkIfFieldDisabled('url', fields, originalLanguageData) },
        [ Validators.pattern(this.urlRegex), urlInvalidCharactersValidator() ]
      ],
      //linkURL:[{value:linkURL ? linkURL : 'https://', disabled: checkIfFieldDisabled('linkURL', fields, originalLanguageData)}, [checkUrlProtocol]],
      linkURL: [
        { value: linkURL ? linkURL : undefined, disabled: checkIfFieldDisabled('linkURL', fields, originalLanguageData) },
        [ Validators.pattern(this.urlRegex), urlInvalidCharactersValidator() ]
      ],
      name :[{value: name ? name : undefined, disabled: checkIfFieldDisabled('name', fields, originalLanguageData)}],
      filter:[{value: filter ? filter : undefined, disabled: checkIfFieldDisabled('filter', fields, originalLanguageData)}],
      altTitle: [{value:altTitle ? altTitle : undefined, disabled: checkIfFieldDisabled('altTitle', fields, originalLanguageData)}],
      fallbackUrl:[{value:fallbackUrl ? fallbackUrl : undefined, disabled: checkIfFieldDisabled('fallbackUrl', fields, originalLanguageData)} , [ checkUrlProtocol,urlInvalidCharactersValidator()]]

    })

    this.billboardImgEditForm.valueChanges.pipe(takeUntil(this.destroy$)).subscribe( value => {
      let {linkURL, url, altTitle} = deepCopy(value)
      if(linkURL=='https://' || linkURL == "")
        linkURL= undefined
      
      if(!this.translationModeOriginal)
        this.returnChanges.emit({
          type:"billboardImage",
          form: this.billboardImgEditForm,
          validForm: this.billboardImgEditForm.valid,
          translations:{url, linkURL, altTitle},
          saveDisabled: !this.billboardImgEditForm.valid
        })
    })

    this.billboardImgEditForm.statusChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.formChange.emit(this.billboardImgEditForm);
    });
  }

  initWidgetEdit(){
    if(this.data['url'])
      this.urlData = this.data['url']
    else{
      if(this.billboardData.url )
        this.urlData = supportUrlStructure(this.billboardData.url, this.passId, this.settingsService.contextId$)

      if(this.billboardData.linkURL)
        this.linkURL = supportUrlStructure(this.billboardData.linkURL, this.passId, this.settingsService.contextId$)
    }

    const {id, filter, imageSize, type, title, subtitle, url, linkURL, name, altTitle, fallbackUrl} = this.billboardData
    this.checkdyanimcContentUrl(url)

    this.billboardImgEditForm = this.fb.group({
      id:[{value: id ? id : undefined, disabled :false}],
      imageSize:[{value: imageSize ? imageSize : undefined , disabled:false}],
      type:[{value:type ? type : undefined, disabled:false}],
      title:[{value: title ? title :undefined, disabled:false}],
      subtitle: [{value: subtitle ? subtitle : undefined, disabled:false}],
      linkURL:[ {value: linkURL ? linkURL : undefined, disabled:false}, [ Validators.pattern(this.urlRegex),urlInvalidCharactersValidator()]],
      url: [{value: this.url ? this.url : undefined, disabled:false} ,[Validators.required, Validators.pattern(this.urlRegex),urlInvalidCharactersValidator()]],
      name:[{value:name ? name : undefined, disabled:false}],
      filter:[{value:filter ? filter : undefined, disabled:false}],
      altTitle:[{value:altTitle ? altTitle : undefined, disabled:false}],
      fallbackUrl:[ {value:fallbackUrl ? fallbackUrl: undefined, disabled:false}, [ Validators.pattern(this.urlRegex),urlInvalidCharactersValidator()]]
    })

    this.setSizeImg(url, imageSize)

    this.billboardImgEditForm.get("linkURL")?.valueChanges.subscribe( (newurl) => {
      this.setFieldValidator('linkURL', newurl)
    })

    this.billboardImgEditForm.get("url")?.valueChanges.subscribe( (newurl) => {
      this.checkdyanimcContentUrl(newurl)
      this.setFieldValidator('url', newurl)
      let urlVlaid

      try {
        urlVlaid = new URL(newurl)
      } catch(eror){}

      if(this.addUrl && urlVlaid){
        this.url = newurl
        if(!this.dynamicUrl)
        this.supportUrl(newurl)
      }

      if(newurl && this.dynamicUrl)
        this.billboardImgEditForm.patchValue({imageSize: [0,0]}, { emitEvent: false })
    })

    this.billboardImgEditForm.valueChanges.subscribe( async (value) => {
      this.setSizeImg(value.url, value.imageSize)
      
      if(value.url && this.dynamicUrl)
        this.billboardImgEditForm.patchValue({imageSize: [0,0]}, { emitEvent: false })
      
      this.returnChanges.emit({
          type:"billboardImage",
          form: this.billboardImgEditForm,
          validForm: this.billboardImgEditForm.valid,
          data:value,
          saveDisabled: !this.billboardImgEditForm.valid
      })

    })


    this.dragFileData = {
      calledFrom: BillboardImgEditFormComponent,
      calledFromData:{
        passId: this.passId,
        widgetNumber:this.widgetNumber,
        widget: "billboardImage",
      },
      enableDragDrop: true,
      enableBrowse:true,
      enableMedia:true,
      enableEnterUrl:true,
      enableMultipleDragDrop:false,
      supportedFileTypes:['image/jpeg', 'image/png', 'image/webp'],
      supportedFileAccept:".jpg, .jpeg, .png, .webp",
      maxSizeInBytes: 2 * 1024 * 1024, // 2 MB size limit for compression,
      maxAllowedSizeInBytes:20 * 1024 * 1024, // 20 MB size limit for direct upload,
      returnSupportUrl: undefined,
      returnUrlData: undefined,
      enterUrl:false,
      returnUrlType:undefined
    }
  }

  setFieldValidator(field, value) {
    if (!value) return;

    if (value.match(/\${(.+)\}/)){
      this.billboardImgEditForm.get(field)?.setValidators([ Validators.pattern(this.urlRegexDynamic)]);
      this.billboardImgEditForm.get(field)?.updateValueAndValidity({ emitEvent: false });
    } else {
      this.checkPattern_url(field)
    }
  }

  checkPattern_url(field){
    const fiedlValue:any = this.billboardImgEditForm.get(field)
    if (fiedlValue){
      try {
        const imgUrl = new URL(fiedlValue)

        if(imgUrl.protocol === "pass:" )
          this.billboardImgEditForm.get(field)?.setValidators([Validators.pattern(this.urlRegexDoc), urlInvalidCharactersValidator()]);

        if(imgUrl.protocol === "https:" || imgUrl.protocol === "http:" || imgUrl.protocol === "tridy:" || imgUrl.protocol === "context:")
          this.billboardImgEditForm.get(field)?.setValidators([Validators.pattern(this.urlRegex), urlInvalidCharactersValidator()]);

       this.billboardImgEditForm.updateValueAndValidity()
      } catch(e){}
    }
  }

  buildAnchorUrl(anchor: { id: string }): string {
    if (!anchor || !anchor.id) {
      console.warn('buildAnchorUrl: invalid anchor', anchor);
      return '';
    }
    return `#${anchor.id}`;
  }

  buildChildPageUrl(child: { id: string }): string {
    if (!child || !child.id) {
      console.warn('buildChildPageUrl: invalid child', child);
      return '';
    }
    return child.id === 'main' ? 'dpp://main' : `child:${child.id}`;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  setLinkUrl(value: string): void {
    const controlName = 'linkURL';
    this.billboardImgEditForm.patchValue({
      [controlName]: value
    });

    const ctrl = this.billboardImgEditForm.get(controlName);
    if (ctrl) {
      ctrl.markAsDirty();
      ctrl.markAsTouched();
      ctrl.updateValueAndValidity();
    }
  }

  private makeLinkChip(value: string | null | undefined): LinkChip | null {
    if (!value) return null;
    // dpp://main
    if (value === 'dpp://main') {
      const match = this.childPages?.find(x => x.id === 'main');
      return { kind: 'child', id: 'main', label: match?.name || 'Main' };
    }
    // child:<id>
    if (value.startsWith('child:')) {
      const id = value.slice('child:'.length).trim();
      if (!id) return null;
      const match = this.childPages?.find(x => x.id === id);
      return {
        kind: 'child',
        id,
        label: match?.name || id,
      };
    }
    // #<id>
    if (value.startsWith('#')) {
      const id = value.slice(1).trim();
      if (!id) return null;
      const match = this.anchorOptions?.find(x => x.id === id);
      return {
        kind: 'anchor',
        id,
        label: match?.label || match?.name || id,
      };
    }
    // normal url -> no chip
    return null;
  }

  clearLinkChip(): void {
    this.setLinkUrl('');
  }

  readDocument(event: any) {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const allowedTypes = [
        'application/pdf',
        'image/jpeg',
        'image/png',
        'image/webp',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'text/plain',
        'text/csv',
        'text/vcard',
        'application/rtf'
      ];
  
      if (!allowedTypes.includes(file.type)) {
        const message = this.translate.instant("SnackBarConstants.INVALID_FILE_FORMAT");
        this.commentService.addSnackBar.emit(message);
        return;
      }
  
      const maxSizeInBytes = 10 * 1024 * 1024; // Example: 10 MB size limit
      if (file.size > maxSizeInBytes) {
        const message = this.translate.instant("SnackBarConstants.FILE_TOO_LARGE");
        this.commentService.addSnackBar.emit(message);
        return;
      }

      const reader = new FileReader();
      this.newImage = file;
      reader.readAsDataURL(file);
  
      reader.onload = async (event) => { 
        if (event.target) {
          const urlNew = event.target.result;
  
          try {
            const uploadURL = await this.uploadService.uploadDocument(this.passId, this.newImage, this.widgetNumber);
            if (uploadURL) {
              this.billboardImgEditForm.get("linkURL")?.setValidators([Validators.required, Validators.pattern(this.urlRegexDoc)]);
              this.linkURL = uploadURL;
              this.billboardImgEditForm.patchValue({ linkURL: this.linkURL });
            }
          } catch (error) {
            console.error('Error uploading document', error);
          }
        }
      };
    }
  }

  checkdyanimcContentUrl(value){
    if(value?.match(/\${(.+)\}/))
    this.dynamicUrl = true
    else
    this.dynamicUrl = false
  }
  
  triggerFileInput(): void {
    this.fileInput.nativeElement.click();
  }

  typeURL(){
    this.addUrl = true
    this.urlData = './../../assets/img/default.jpg';
  }

  checkNewUrl(){
    if(!this.dynamicUrl){
      this.url = this.billboardImgEditForm.value.url
      let validURL
      try{
        validURL = new URL(this.url)
        validURL = true
      }catch(eror){
        validURL = false
      }
      if(validURL)
      this.urlData = supportUrlStructure(this.billboardImgEditForm.value.url, this.idToShow, this.settingsService.contextId$)
    }
  }


  deleteImg(url){
    this.changes=true
    this.url=""
    this.billboardImgEditForm.patchValue({url: this.url, imageSize:undefined, altTitle:undefined, fallbackUrl: undefined})
    this.urlData=""
  }

  supportUrl(url){
    this.urlData = url
    if(url){
      const newurl = supportUrlStructure(url, this.passId, this.settingsService.contextId$)
      this.urlData = newurl
    }
  }

  supportLinkUrl(linkurl){
    if(linkurl){
      const newurl = supportUrlStructure(linkurl, this.passId, this.settingsService.contextId$)
      this.linkURL=newurl
    }
  }


  returnChangesFilters($event){
    this.billboardImgEditForm.patchValue({filter: $event.newFilters})
  }

  browserFromMediaFolder(){
    let dialogRef= this.dialog.open(MediaDialogHandlerComponent, {
      data: {
        supportedFiles: ['.jpg', '.jpeg', '.png', '.webp']
      },
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if(result[0]){
        const url = result[1]
        const supportUrl = result[2]
        
        this.url = url
        this.urlData = supportUrl
        this.changes = true;
        this.billboardImgEditForm.patchValue({ url: this.url });
        this.noUrl = false;
      }
    });
  }

  returnChangesDragFileBrowseUI($event){
    if($event){
      const {calledFrom, calledFromData, enableDragDrop, enableBrowse, enableMedia,enableEnterUrl, enableMultipleDragDrop, 
        supportedFileTypes,supportedFileAccept, maxSizeInBytes,maxAllowedSizeInBytes, 
        returnSupportUrl,returnUrlData, enterUrl} = $event

        this.dragFileData = $event
      if(enterUrl){
        this.typeURL()
      }else{
        this.addUrl = false
        this.urlData = undefined
      }

      if(returnUrlData)
      this.urlData = returnUrlData

      if(returnSupportUrl){
        this.noUrl = false
        this.url = returnSupportUrl
        this.billboardImgEditForm.patchValue({ url: returnSupportUrl })
      }
    }
  }

  async setSizeImg(url, imageSize){
    if(url ){
      this.checkdyanimcContentUrl(url)
      if( !this.dynamicUrl){
        if(imageSize?.length == 0 || !imageSize || (imageSize && imageSize[0] == 0 && imageSize[1] == 0) ){
          let url = this.urlData
          if (url && typeof url === 'object' && 'changingThisBreaksApplicationSecurity' in url) {
            url = supportUrlStructure(url, this.passId, this.settingsService.contextId$)
          }
          await this.uploadService.calculateImgFileSize(url).then(value => {
            this.billboardImgEditForm.patchValue({imageSize: value})
          })
        }
      }
    }
  }
}
